import { FormSubmissionListItem } from '@interfaces';
import { EmailStatusBadgeType } from '../../components/email-status-badge/email-status-badge.types';
import { EmailListItemData } from '../../components/email-list-item/email-list-item.types';

export function mapFormSubmissionToEmailListItem(
  item: FormSubmissionListItem,
  isActive: boolean = false,
): EmailListItemData {
  let statusType: EmailStatusBadgeType = 'DEFAULT';
  if (
    item.reason.toLowerCase().includes('concrete') ||
    item.reason.toLowerCase().includes('concreto')
  ) {
    statusType = 'CONCRETE';
  } else if (
    item.reason.toLowerCase().includes('viguetas') ||
    item.reason.toLowerCase().includes('beams')
  ) {
    statusType = 'BEAMS';
  } else if (
    item.reason.toLowerCase().includes('pago') ||
    item.reason.toLowerCase().includes('payment')
  ) {
    statusType = 'PAYMENTS';
  }

  const date = new Date(item.formSubmissionDate);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  let timeDisplay: string;
  if (date.toDateString() === today.toDateString()) {
    timeDisplay = date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } else if (date.toDateString() === yesterday.toDateString()) {
    timeDisplay = 'Ayer';
  } else if (date.getTime() > today.getTime() - 7 * 24 * 60 * 60 * 1000) {
    timeDisplay = date.toLocaleDateString('es-ES', { weekday: 'short' });
  } else {
    timeDisplay = date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
    });
  }

  return {
    id: item.id,
    subject: item.fullName,
    sender: item.email.split('@')[0],
    preview:
      item.message.length > 50
        ? item.message.substring(0, 47) + '...'
        : item.message,
    time: timeDisplay,
    statusType,
    statusLabel: item.reason,
    unreadCount: item.isViewed ? 0 : 1,
    isActive,
  };
}
